import { render, staticRenderFns } from "./ConfigModelMain.vue?vue&type=template&id=36c76902&"
import script from "./ConfigModelMain.vue?vue&type=script&lang=js&"
export * from "./ConfigModelMain.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModelMain.vue?vue&type=style&index=0&id=36c76902&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports